import type { ListControlProps } from '../../declare'
import { useMemo } from 'react'
import { DatePicker } from 'src/components'
import { DATA_TYPE_mapto_DATE_TYPE } from 'src/components/root/helper'

const DateControl = (props: ListControlProps) => {
  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const dateType = useMemo(() => {
    return DATA_TYPE_mapto_DATE_TYPE(props.config.DATA_TYPE)
  }, [props.config.DATA_TYPE])

  const { PROMPT_INFO } = props.config
  return (
    <DatePicker
      value={props.value}
      dateType={dateType}
      datePicker={{ placeholder: PROMPT_INFO }}
      onChange={handleChange}
    />
  )
}

export default DateControl